import request from 'request/index'
import { E_PRODUCT_RES, E_PRODUCT2_RES } from 'utils/config'
export default {
  /**
   * 2.1.1.6 搜索产品信息列表[get] /c/products?$count=true&$offset=0&$limit=200
   */
  sGetProdcutList ({
    $count = true,
    $limit = 8,
    $offset = 0,
    key,
    support_user,
    language_id
  } = {}) {
    return request({
      method: 'GET',
      res: E_PRODUCT_RES,
      api: '/visitor/products',
      query: {
        $count,
        $limit,
        $offset,
        key,
        support_user,
        language_id
      }
    })
  },
  /**
   * 3.1.2.1 获取产品推荐信息列表[get] /visitor/products/recommend
   */
  sGetRecommendProdcutList ({
    $count = true,
    $limit = 10,
    $offset = 0,
    language_id,
    support_user
  } = {}) {
    return request({
      method: 'GET',
      res: E_PRODUCT2_RES,
      api: '/visitor/products/recommend',
      query: {
        $count,
        $limit,
        $offset,
        language_id,
        support_user
      }
    })
  },
    /**
   * 2.1.2.7 获取产品推荐信息列表[get] /c/products/recommend
   */
  cGetRecommendProdcutList ({
    $count = true,
    $limit = 10,
    $offset = 0,
    language_id,
    support_user
  } = {}) {
    return request({
      method: 'GET',
      res: E_PRODUCT2_RES,
      api: '/c/products/recommend',
      query: {
        $count,
        $limit,
        $offset,
        language_id,
        support_user
      }
    })
  },
  /**
   *  2.1.2.5获取产品绑定标签列表 [get] /c/products/{product_id}/system_flags?$count=false&$offset=偏移量&$limit=数量
   */
  sGetSystemFlag ({
    product_id,
    $count = true,
    $offset = 0,
    $limit = 10
  }) {
    return request({
      method: 'GET',
      res: E_PRODUCT_RES,
      api: '/c/products/{product_id}/system_flags',
      params: {
        product_id
      },
      query: {
        $count,
        $offset,
        $limit
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/edmodo/product.js